type ChartData = {
  legend: string,
  series: unknown[]
  categories: unknown[]
}

export const getDashboardChartData = ({legend, series, categories}: ChartData) => {

  return {
    series: [{
      name: legend,
      data: series
    }],
    colors: ['#00919B'],
    chart: {
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      },
    },
    xaxis: {
      categories: categories,
      position: 'bottom',
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      labels: {
        show: true,
        hideOverlappingLabels: true,
        showDuplicates: false,
        trim: false,
        style: {
          colors: '#868686'
        }
      }
    },
    yaxis: {
      show: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 12,
      }
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'gradient',
      gradient: {
        type: "vertical",
        gradientToColors: ['#00AEB9']
      }
    },
    annotations: {
      yaxis: [
        {
          y: 0,
          strokeDashArray: 0,
          borderColor: "#333",
          fillColor: "#c2c2c2",
          opacity: 0.8,
          offsetX: 0,
          offsetY: 0
        }
      ]
    },
    grid: {
      yaxis: {
        lines: {
          show: false
        }
      }
    },
  }
}